import styled from "styled-components";

export const ComingSoonStyled = styled.div`
  display: flex;
  height: 100vh;
  text-align: center;
  justify-content: center;
  align-items: center;
`;
